<template>
  <div class="main-container px-8">
    <workflow />
  </div>
</template>

<script>
import Workflow from '@/modules/Workflow/components/Workflow'
export default {
  name: 'WorkflowMain',
  components: {
    Workflow
  }
}
</script>

<style scoped lang="scss">
.main-container {
  height: calc(100vh - 120px);
}
</style>